module.exports = __webpack_public_path__ + "media/images/category/feature/echigo/bg-echigo-c672a28747f9e5407c20c0e558643005.png";